import { WithdrawalType } from '../enums';

interface Payload {
    amount?: number;
    email?: string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: Date;
    shopId?: number;
}

export default interface WithdrawalRequest {
    amount: number;
    type: WithdrawalType;
    shopId?: string;
    paymentInstrumentType?: string;
    psc?: boolean;
    email?: string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: string;
}

export function createInstantRequest(payload: Payload) {
    return {
        amount: payload.amount,
        shopId: payload.shopId,
        type: WithdrawalType.instant,
    };
}

export function createShopRequest(payload: Payload) {
    return {
        amount: payload.amount,
        shopId: payload.shopId,
        type: WithdrawalType.shop,
    };
}

export function createBankTransferRequest(payload: Payload) {
    return {
        amount: payload.amount!,
        type: WithdrawalType.bankTransfer,
        paymentInstrumentType: 'BankTransfer',
        psc: false,
    };
}

export function createPscTransferRequest(payload: Payload) {
    return {
        amount: payload.amount!,
        type: WithdrawalType.bankTransfer,
        psc: true,
        email: payload.email!,
        firstName: payload.firstName!,
        lastName: payload.lastName!,
        dateOfBirth: payload.dateOfBirth!.toLocaleString()
    };
}

export function createOnlineRequest(payload: Payload) {
    return {
        amount: payload.amount,
        type: WithdrawalType.online,
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/models/user/withdrawal/WithdrawalRequest.ts